/* ==========================================================================
 *  Function: Add navingation scroll
 * ======================================================================= */
function fn_parts_navigation_scroll_resize(){
	if ($( '.navigation' ).length){
		if ($(window).scrollTop() > 1 && $(window).width() > bp_medium) {
			$( '.navigation' ).addClass( 'navigation-scroll' );
		} else {
			$( '.navigation' ).removeClass( 'navigation-scroll' );
		}
	}
}
